import { ErrorResponse } from "@/app/types/error";
import { getItemSessionStorage } from "@/lib/utils";
import { ELocalStorageKeys } from "@/app/types/localStorage";
import { AddNewPatientDTO, ConnectionDTO } from "./types";
import { getApi, patchApi, postApi } from "../config";

export const addNewConnection = async (
  data: AddNewPatientDTO
): Promise<{ status: string; data: ConnectionDTO } | ErrorResponse> => {
  const token = await getItemSessionStorage(ELocalStorageKeys.TOKEN);

  const response = await postApi<
    { status: string; data: ConnectionDTO } | ErrorResponse
  >("/connection/add", { body: data }, token);

  if (response.status === "fail") return response as ErrorResponse;
  return response;
};

export const cancelConnection = async (
  connectionId: string
): Promise<{ status: string } | ErrorResponse> => {
  const token = await getItemSessionStorage(ELocalStorageKeys.TOKEN);

  const response = await patchApi<{ status: string } | ErrorResponse>(
    `/connection/${connectionId}/cancel`,
    {},
    token
  );

  if (response.status === "fail") return response as ErrorResponse;
  return response;
};

export const getConnection = async (
  connectionId: string
): Promise<{ status: string; data: ConnectionDTO } | ErrorResponse> => {
  const token = await getItemSessionStorage(ELocalStorageKeys.TOKEN);

  const response = await getApi<
    { status: string; data: ConnectionDTO } | ErrorResponse
  >(`/connection/${connectionId}`, {}, token);

  if (response.status === "fail") return response as ErrorResponse;
  return response;
};

export const getAllConnections = async (): Promise<
  { status: string; data: ConnectionDTO[] } | ErrorResponse
> => {
  const token = await getItemSessionStorage(ELocalStorageKeys.TOKEN);

  const response = await getApi<
    { status: string; data: ConnectionDTO[] } | ErrorResponse
  >("/connection/patients", {}, token);

  if (response.status === "fail") return response as ErrorResponse;
  return response;
};

export const getAcceptedConnections = async (): Promise<
  { status: string; data: ConnectionDTO[] } | ErrorResponse
> => {
  const token = await getItemSessionStorage(ELocalStorageKeys.TOKEN);

  const response = await getApi<
    { status: string; data: ConnectionDTO[] } | ErrorResponse
  >("/connection/accepted", {}, token);

  if (response.status === "fail") return response as ErrorResponse;
  return response;
};
